<template>
    <bscroll-view :pull-up-handler="loadMore">
        <div class="knowledge-book-rec">
            <div class="content-body">
                <div class="common-cut-header">
                    <h5 v-if="paginate.total > 0">
                        {{ langTransfer(`共${paginate.total}种`) }}
                    </h5>
                </div>
                <section class="common-resource-section knowledge-book-group">
                    <div class="resource-list">
                        <div v-for="(item,i) in list"
                             :key="i"
                             class="item"
                             @click="detailDispatcher('knowledgeBook',item)"
                        >
                            <div class="hb-resource-cover knowledge-item-cover lr-img-scale lr-high-light
                            lr-book-cover"
                            >
                                <img :src="item.poster">
                            </div>
                            <div class="name text1line">
                                {{ langTransfer(item.name) }}
                            </div>
                        </div>
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                    </div>
                </section>
                <div class="warning-wrap">
                    <div v-show="list.length > 0 && list.length >= paginate.total"
                         class="has-no-more"
                    >
                        {{ langTransfer('- 没有更多了 -') }}
                    </div>
                </div>
            </div>
            <footer-com />
        </div>
    </bscroll-view>
</template>

<script>
    import BscrollView from '@/components/bscrollView'
    import FooterCom from '@/components/footerCom/footerCom'
    import { moreResourcesPageList } from '../../api/lyl'

    export default {
        name: 'Home',
        components: {
            FooterCom,
            BscrollView
        },
        data () {
            return {
                list: [],
                paginate: {
                    page: 1,
                    pageSize: 18,
                    total: 0
                }
            }
        },
        computed: {
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.moreResourcesPageList()
                }
            }
        },

        created () {
        },
        mounted () {
            const { service_code } = this.webInfo
            if (service_code) {
                this.moreResourcesPageList()
            }
        },
        methods: {
            itemClickHandler (item) {
                const { query, fullPath } = this.$route
                const { href } = this.$router.resolve({
                    path: '/occupationBookDetail',
                    query: {
                        id: item.id,
                        p0Name: query.p0Name,
                        p0FullPath: fullPath
                    }
                })
                window.open(href, '_blank')
            },
            async moreResourcesPageList (bscrollObj) {
                try {
                    const { page, pageSize } = this.paginate
                    const { id: unique_code } = this.$route.params
                    const data = await moreResourcesPageList({
                        service_code: this.webInfo.service_code,
                        unique_code,
                        type: 8,
                        page,
                        pageSize
                    })
                    if (page !== 1 && bscrollObj) {
                        bscrollObj.finishPullUp()
                    }
                    this.list = this.list.concat(data.records)
                    this.paginate.total = data.total
                } catch (err) {
                    console.log(err)
                }
            },
            loadMore (bscrollObj) {
                const { page, pageSize, total } = this.paginate
                if (page * pageSize < total) {
                    this.paginate.page += 1
                    this.moreResourcesPageList(bscrollObj)
                }
            }
        }
    }
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .knowledge-book-group {
        .item {
            width: 180px;
            .hb-resource-cover {
                width: 180px;
            }
        }
  }
}
@media screen and (max-width: 1280px) {
  .knowledge-book-group {
        .item {
            width: 154px;
            .hb-resource-cover {
                width: 154px;
            }
        }
  }
}
    .knowledge-book-rec {
        width: 100%;
        min-height: calc(100vh - 60px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .content-body {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .common-cut-header {
            margin-top: 50px;
        }
    }

    .knowledge-book-group {
        width: 1200px;
        margin-top: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;

        .item {
            border-radius: 8px;
            margin-bottom: 20px;
            overflow: hidden;
            cursor: pointer;
            transition: .3s;

            .hb-resource-cover {
            }

            .name {
                font-size: 15px;
                font-family: AlibabaPuHuiTiM;
                color: #303133;
                line-height: 24px;
                margin-top: 10px;
            }
        }
    }

    .warning-wrap {
        height: 40px;
        margin-top: 40px;
        margin-bottom: 80px;

        .has-no-more {
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: rgb(170, 169, 169);
            line-height: 40px;
            user-select: none;
        }
    }
</style>
